<div class="content">
    <div *ngIf="product" class="price-card">
        <!-- HEADER SIEMPRE VISIBLE -->
        <div class="price-card-header" (click)="isExpanded = !isExpanded" style="cursor: pointer;">
            <div class="image-wrapper">
                <div class="image-loader" *ngIf="!imageLoaded">
                    <div class="spinner"></div>
                </div>
                <img [src]="product.images[0].url" [alt]="product.images[0].altText" (load)="imageLoaded = true"
                    [class.hidden]="!imageLoaded" />
            </div>
            <div class="product-data-container">
                <div class="product-data-container-title" (click)="onEdit(product.id!)">
                    <h3>{{ product.name }}</h3>
                    <div>
                        <i class="fa fa-pencil-square-o" title="Editar precios" style="margin-right: 10px;"></i>
                        <p>Editar</p>
                    </div>
                </div>
                <div class="product-data">
                    <div class="external-data">
                        <p>ID {{ product.externalId }}</p>
                    </div>
                    <div class="brand-data">
                        <p><span>Marca </span>{{ product.brand.name }}</p>
                    </div>
                    <div class="category-data">
                        <p><span>Categoría </span>{{ product.category.name }}</p>
                    </div>
                </div>
            </div>
            <div class="toggle-icon">
                <i class="fa" [ngClass]="isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </div>
        </div>
        <div *ngIf="isExpanded" class="price-card-body">
            <div class="base-price-container">
                <p>Precio Base: <span>{{product.basePrice.amount}} {{product.basePrice.currency}}</span></p>
                <p>Precio Final: <span>{{product.finalBasePrice?.amount}}
                        {{product.finalBasePrice?.currency}}</span></p>
            </div>
        </div>
        <div *ngIf="isExpanded" class="price-card-branch-body">
            <div class="branch-price-header" *ngFor="let branch of product.pricing.branches">
                <div class="branch-base-data">
                    <p>SUCURSAL <br /> <span>{{branch.name || "-"}}</span></p>
                </div>
                <div class="prices-container">
                    <div *ngFor="let prices of branch.prices" class="prices-data">
                        <div>
                            <p>Precio: <span>{{prices.amount}} {{prices.currency}}</span></p>
                        </div>
                        <div>
                            <p>Cantidad: <span>{{prices.quantity}}</span></p>
                        </div>
                        <div>
                            <p>Tipo: <span>{{prices.type}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isExpanded" class="discount-container">
            <div class="discount-data">
                <p>
                    CÓDIGO: <span>{{product.discount?.code}}</span>
                </p>
                <p>
                    TIPO: <span>{{product.discount?.type==="PERCENTAGE" ? "Porcentaje" : product.discount?.type}}</span>
                </p>
                <p>
                    VALOR: <span>{{product.discount?.value}}</span>
                </p>
                <p>
                    EXPIRA: <span>{{product.discount?.expiration | date: 'dd-MM-yyyy HH:mm'}}</span>
                </p>
            </div>
        </div>
    </div>
</div>